<template>
  <div class="statistics mt-5 mb-5">
    <div class="site-wrapper">
      <div class="main-wrapper">
        <div class="container-fluild mb-5">
          <div class="title">Thống kê</div>
          <div class="row layout mt-5">
            <div class="col-12 col-md-8 overview-block">
              <div class="overview container-fluid">
                <div class="row d-flex justify-content-between">
                  <div class="col-6 col-md-4 block">
                    <div class="card pt-4 pb-4 pl-3 pr-3" style="color: #4F67E1">
                      <div class="card-content d-flex align-items-center justify-content-center">
                        <div class="info d-flex flex-wrap">
                          <div class="val w-100 mb-2 d-flex align-items-center justify-content-between">
                            <span>{{ getTeacherRatingPoint }}</span>
                            <div class="icon d-flex justify-content-center align-items-center">
                              <div class="icon-block p-2 d-flex justify-content-center align-items-center">
                                <b-icon-star />
                              </div>
                            </div>
                          </div>
                          <div class="title w-100">Đánh giá giảng viên</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-4 pb-1 block">
                    <div class="card pt-4 pb-4 pl-3 pr-3" style="color: #FF4874">
                      <div class="card-content d-flex align-items-center justify-content-center">
                        <div class="info d-flex flex-wrap">
                          <div class="val w-100 mb-2 d-flex align-items-center justify-content-between">
                            <span>{{ get(user, 'statistics.course_count') }}</span>
                            <div class="icon d-flex justify-content-center align-items-center">
                              <div class="icon-block p-2 d-flex justify-content-center align-items-center" style="background: #FFCDD4">
                                <b-icon-file-text />
                              </div>
                            </div>
                          </div>
                          <div class="title w-100">Tổng số khóa học</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-4 pb-1 block">
                    <div class="card pt-4 pb-4 pl-3 pr-3" style="color: #FFBA55">
                      <div class="card-content d-flex align-items-center justify-content-center">
                        <div class="info d-flex flex-wrap">
                          <div class="val w-100 mb-2 d-flex align-items-center justify-content-between">
                            <span>{{ get(user, 'statistics.student_count') }}</span>
                            <div class="icon d-flex justify-content-center align-items-center">
                              <div class="icon-block p-2 d-flex justify-content-center align-items-center" style="background: #fff5e7">
                                <b-icon-person />
                              </div>
                            </div>
                          </div>
                          <div class="title w-100">Tổng số học viên</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="top-title">
                  <span class="title">Thống kê</span>
                  <div class="total">
                    <span style="font-size: 12px">Tổng thu nhập từ {{formatTime(times[0], 'DD/MM')}} - {{formatTime(times[1])}}: </span>
                    <span style="font-weight: bold; color: rgb(79, 103, 225)">{{ total | vnd }}</span>
                  </div>
                </div>
                <div class="function">
                  <div class="left">
                    <el-select
                      v-if="courses"
                      v-model="course"
                      placeholder="Toàn bộ khóa học"
                      size="mini"
                      value-key="name"
                      clearable
                      style="min-width: 200px"
                      @change="initCommissionStatistics"
                    >
                      <el-option
                        v-for="course in courses"
                        :key="course._id"
                        :label="course.name"
                        :value="course"
                      />
                    </el-select>
                  </div>
                  <div class="right">
                    <el-date-picker
                      v-model="times"
                      size="mini"
                      type="daterange"
                      range-separator="-"
                      format="dd/MM/yyyy"
                      start-placeholder="Từ ngày"
                      end-placeholder="Đến ngày"
                      :clearable="false"
                      style="width: 250px; margin-right: 14px"
                      @change="initCommissionStatistics"
                    />
                    <el-button
                      size="mini"
                      circle
                      style="background-color: #F9F9F9; border: none"
                      @click="exportExcel"
                    >
                      <img src="@/assets/images/icons/excel.svg" style="height: 16px; width: 16px">
                    </el-button>
                  </div>
                </div>
                <div class="chart-main">
                  <BarChart
                    :height="424"
                    :chart-data.sync="comissionChartData"
                    :options="{
                      responsive: true,
                      maintainAspectRatio: false,
                      layout: {
                        padding: 0
                      },
                      scales: {
                        yAxes: [{
                          stacked: true,
                          ticks: {
                            suggestedMin: 0
                          }
                        }],
                        xAxes: [{
                          gridLines: {
                            display: false
                          },
                          stacked: true
                        }]
                      }
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="commission-recently">
                <div class="title d-flex justify-content-between align-items-center">
                  <div class="left-title d-flex align-items-center">
                    <b-icon-clock-history/>
                    <span class="pl-1">Nguồn thu gần đây</span>
                  </div>
                  <div class="right-title d-flex align-items-center">
                    <router-link :to="{ name: 'CommissionList' }">
                      <span class="pr-1">Xem tất cả</span>
                      <b-icon-chevron-right/>
                    </router-link>
                  </div>
                </div>
                <div v-if="!commissions || commissions.length === 0" class="empty">
                  <img alt="empty" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K">
                  <div class="mt-2 w-100 text-center">Chưa có nguồn thu nào gần đây</div>
                </div>
                <div v-else class="commissions-view">
                  <div
                    v-for="(item, index) in commissions"
                    :key="item._id"
                    class="commission-card pl-1 pr-1"
                  >
                    <div
                      :style="index !== commissions.length - 1 ? 'border-bottom: 1px solid #D8D7D6;' : ''"
                      class="pb-2 pt-2 h-100 w-100"
                    >
                      <div class="inner p-2 d-flex align-content-around">
                        <div class="img-box left h-100">
                          <img :src="item.course.thumbnail_url | getMediaUrl" alt="Learnova"/>
                        </div>
                        <div class="right h-100 w-100 d-flex align-items-center pl-3 flex-wrap">
                          <div class="course-name w-100">{{ item.course.name }}</div>
                          <div class="created-at w-100">{{ item.created_at | getDate }}</div>
                          <div class="order w-100 d-flex justify-content-between align-items-center">
                            <span class="d-flex">
                              <span class="icon-block pr-1 d-flex justify-content-center align-items-center">
                                <b-icon-person />
                              </span>
                              <span>
                                {{ get(item, 'order.user.profile.fullname') }}
                              </span>
                            </span>
                            <span class="total" :style="item.commission < 0 ? 'color: rgb(255, 72, 116)': ''">
                              {{ item.commission | vnd }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="commission-total d-flex flex-wrap align-items-center">
                <div class="card-title w-100">
                  <img src="@/assets/images/icons/money.svg" style="max-width: 24px; max-height: 24px" />
                  <span class="pl-1">Tổng doanh thu từ Learnova</span>
                </div>
                <div class="card-value w-100 text-right">
                  {{ commissionStatistics ? commissionStatistics.total : 0  | vnd}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'

import BarChart from '@/components/chart/Bar'

export default {
  components: {
    BarChart
  },
  computed: {
    ...mapGetters({
      user: 'user',
      courses: 'courses',
      commissions: 'commissions',
      commissionStatistics: 'commissionStatistics'
    }),
    getTeacherRatingPoint() {
      const sum = _.get(this.user, 'statistics.rating.points_sum') || 0
      const count = _.get(this.user, 'statistics.rating.count') || 1

      return (sum / count).toFixed(2)
    }
  },

  data() {
    return {
      times: [],
      course: null,
      comissionChartData: null,
      total: 0
    }
  },

  created() {
    this.init()
    this.initCommissions()
  },

  methods: {
    init() {
      const times = [
        moment().startOf('month').toDate(),
        moment().toDate()
      ]
      this.$set(this, 'times', times)
      this.initCourse()
      this.initCommissions()
      this.initCommissionStatistics()
    },

    formatTime(time, format) {
      return moment(time).format(format || 'DD/MM/YYYY')
    },

    async initCommissionStatistics() {
      const query = {
        from: moment(this.times[0]).toDate(),
        to: moment(this.times[1]).toDate()
      }

      if (this.course && this.course._id) {
        Object.assign(query, {
          course_id: this.course._id
        })
      }

      await this.$store.dispatch('course/GetCommissionStatistics', query)

      // Caculate total
      this.total = 0
      this.commissionStatistics.data.forEach(item => {
        this.total += item.value
      })

      this.initCommissionChart()
    },

    initCommissions() {
      this.$store.dispatch('course/GetCommissions', {
        page: 1,
        limit: 4
      })
    },

    async initCourse() {
      if (!this.courses) {
        await this.$store.dispatch('course/GetCourses', {
          sort: '-created_at'
        })
      }
    },

    exportExcel() {
      import('@/utils/excel').then(excel => {
        const header = ['Thời gian', 'Số tiền thu từ khóa học', 'Số tiền thu từ giới thiệu']
        const filterVal = ['label', 'value', 'referal']
        const data = this.formatJson(filterVal, this.commissionStatistics.data)
        const start = moment(this.times[0]).format('DD-MM')
        const end = moment(this.times[1]).format('DD-MM-YYYY')
        data.push([], [], [`Thống kê doanh thu giảng viên ${this.user.fullname}`, `${moment().format('HH:mm:ss DD-MM-YYYY')}`])
        data.push(['Khoảng thời gian', `${start} -> ${end}`])
        const temp = this.course ? [this.course] : this.courses
        temp.forEach((course, index) => {
          data.push([index === 0 ? 'Khóa học' : '', course.name])
        })

        excel.export_json_to_excel({
          header,
          data,
          filename: `tk_gv_${this.user.fullname}_${start}_${end}`,
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        const xj = j.split('@')
        let val = this.get(v, xj[0])
        if (xj.length > 0) {
          switch (xj[1]) {
            case 'date':
              val = moment(val).format('DD-MM-YYYY')
              break
          }
        }

        return val
      }))
    },

    initCommissionChart() {
      this.$set(this, 'comissionChartData', {
        labels: this.commissionStatistics.data.map(item => item.label),
        datasets: [
          {
            label: 'Khóa học',
            backgroundColor: '#4F67E1',
            data: this.commissionStatistics.data.map(item => item.value),
            maxBarThickness: 100
          }
        ]
      })
    },

    get(obj, path) {
      return _.get(obj, path)
    }
  }
}
</script>

<style lang="scss">
.statistics {
  .top-title {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    font-family: Inter;
  }

  .commission-recently {
    background: #F5F8FD;
    width: 100%;
    box-shadow: 0px 4px 5px rgba(238, 232, 227, 0.5);
    border-radius: 10px;
    height: 566px;
    padding: 15px;

    .title {
      color: #848B96;
      font-size: 12px;
      border-bottom: 1px solid #D8D7D6;
      height: 32px;
      margin-bottom: 12px;

      .left-title {
        text-transform: uppercase;
      }
    }

    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
    }

    .commission-card {
      height: 123px;
      position: relative;

      .inner {
        height: 100%;
        width: 100%;
        color: #403B36;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 12.5px;

        .img-box {
          width: 120px;
          display: table;
          vertical-align: middle;
        }

        img {
          max-height: 80px;
          max-width: 120px;
          border-radius: 10px;
        }

        .course-name {
          width: 100%;
          font-weight: bold;
          max-height: 44px;
        }

        .created-at {
          color: #848B96;
        }

        .total {
          color: #4477DB;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }

  .commission-total {
    margin-top: 12px;
    background: #4F67E1;
    box-shadow: 0px 10px 30px rgba(68, 119, 219, 0.3);
    border-radius: 10px;
    height: 132px;
    padding: 14px;
    color: #ffffff;

    .card-value {
      font-family: 'Muli';
      font-size: 28px;
    }
  }

  .chart {
    margin-top: 12px;
    background: #FFFFFF;
    border: 1px solid #EEF0F2;
    box-shadow: 0px 4px 5px rgba(238, 232, 227, 0.5);
    border-radius: 5px;
    height: 566px;
    width: 100%;
    padding: 15px;

    .title {
      margin-bottom: 12px;
      height: 32px;
    }

    .function {
      height: 56px;
      margin-bottom: 12;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  .overview {
    .block {
      height: 132px;
      padding: 0;
    }

    .col-6.block {
      max-width: 48% !important;
    }

    .col-md-4.block {
      max-width: 32% !important;
    }

    .card {
      background: #FFFFFF;
      border: 1px solid #EEF0F2;
      box-shadow: 0px 4px 5px rgba(238, 232, 227, 0.5);
      border-radius: 10px;

      .title {
        font-weight: bold;
        color: #848B96;
        font-size: 14px;
      }

      .val {
        font-size: 36px;
        font-weight: bold;
      }

      .icon {
        .icon-block {
          border-radius: 50%;
          width: 40px;
          height: 40px;
          background: #EFF4FF;
          border: 1px solid #EEF0F2;
          font-size: 22px;
        }
      }
    }
  }
}
</style>
